import BASEURLGESTTOR from '../api/gesttor'
import { cadastrarProcessos, paramsListaProcessos, processosAtualizarPayload } from '../../interfaces/processos'

export function novoProcesso (payload: cadastrarProcessos) {
    return BASEURLGESTTOR.post('/processos', payload)
}

export function listarProcessos (paramns: paramsListaProcessos) {
    return BASEURLGESTTOR.get(`/processos?cliente=${paramns.cliente}&situacao=${paramns.situacao}&processosEscritorio=${paramns.processosEscritorio}&dataInicial=${paramns.dataInicial}&dataFinal=${paramns.dataFinal}&titulo=${paramns.titulo || ""}&idModeloProcesso=${paramns.idModeloProcesso || ""}&responsavel=${paramns.responsavel || ""}&tipoData=${paramns.tipoData || "criado"}`)
}

export function atualizarProcesso (idProcesso: string, payload: processosAtualizarPayload) {
    return BASEURLGESTTOR.patch(`/processos?idProcesso=${idProcesso}`, payload)
}

export function tarefasProcesso (idProcesso:string) {
    return BASEURLGESTTOR.get(`/processos/tarefas?idProcesso=${idProcesso}`)
}

export function apagarProcesso (idProcesso: string) {
    return BASEURLGESTTOR.delete(`/processos?idProcesso=${idProcesso}`)
}